/**
 * Which screen a locked widget holds the applicant on.
 *
 * Only read when `widgetLocked` is true. Absent means HOLDING_SCREEN — the
 * behaviour the lock shipped with — so every brand locked before this
 * existed keeps showing exactly what it showed yesterday.
 *
 * Set per brand in vroom admin; mirrored there as `src/types/EWidgetLockScreen.ts`.
 */
export enum EWidgetLockScreen {
    /** The "coming soon" holding screen with the dealer's phone number. */
    HOLDING_SCREEN = 'HOLDING_SCREEN',
    /**
     * The partner's own first screen, rendered but frozen — whatever
     * getInitialDisplayScreen resolves for them, not a named screen.
     */
    FROZEN_FIRST_SCREEN = 'FROZEN_FIRST_SCREEN',
}
